import { SurveyQuestionType } from 'constant';
import { createContext, useCallback, useContext, useState } from 'react';

import { addUserMessage, toggleMsgLoader, toggleInputDisabled, InputEnabled, InputDisabled } from 'components/ChatWidget';
import { useTranslation } from 'react-i18next';
import { ChatMessage } from 'interface';
export const ChatbotContext = createContext<any>({});

export const ChatbotProvider = ({ children }) => {
    const { t, i18n } = useTranslation();
    const [convo, setConvo] = useState([]);
    const [Questionid, setQuestionId] = useState(null);
    const [inputDisabled, setInputDisabled] = useState(false);
    const [messageLoader, setMessageLoader] = useState(false);
    const [statesurveyStatus, setSurveyStatus] = useState(null);
    const [surveylanguages, setSurveyLanguages] = useState([]);
    const [statesessionId, setSessionId] = useState(null);
    const [addSessionLoading, setAddSessionLoading] = useState(false);
    const [botReplyLoading, setBotReplyLoading] = useState(false);
    const [documentDownloading, setDocumentDownloadLoading] = useState(false);
    const [newBotSessionLoading, setNewBotSessionLoading] = useState(false);
    const [sessionMessagesLoading, setSessionMessagesLoading] = useState(false);
    const [actionSelected, setActionSelected] = useState(false);
    const [sessionChatHistory, setSessionChatHistory] = useState<ChatMessage[]>([]);
    const [botControllers, setBotControllers] = useState({});
    const [intentActionBtnQuery, setIntentActionBtnQuery] = useState(null);
    const [botDetail, setBotDetail] = useState(null);
    const [selectedQuickAction, setSelectedQuickAction] = useState(null);
    const [showQuickActions, setShowQuickActions] = useState(true);
    const [isGeneralQuerySelected, setIsGeneralQuerySelected] = useState(false);
    const [expanded, setExpanded] = useState(false);


    const ChatInputToggle = () => {
        setInputDisabled((prev) => {
            if (prev) {
                return false;
            } else {
                return true;
            }
        });
        toggleInputDisabled();
    };

    const InputEnabledChat = () => {
        InputEnabled();
    };

    const InputDisabledChat = () => {
        InputDisabled();
    };

    const MessageLoaderToggle = () => {
        setMessageLoader((prev) => !prev);
        toggleMsgLoader();
    };

    const HandleResponse = useCallback(
        (e: any, optionIndex, item: any, skip: boolean = false, undo: boolean = false, handleNewUserMessage) => {
            try {
                if (!undo) {
                    //setLoading(true);
                    // toggleMsgLoader();
                    let message = !skip
                        ? item.question_type === SurveyQuestionType.COMMENT_LIST
                            ? e
                            : e.map((x) => x.label)
                        : [t('SKIP')];

                    var clientMessageList = null;
                    var clientMessage = message;

                    if (message.length > 1) {
                        clientMessageList = message;
                        clientMessage = clientMessageList.join();
                    } else {
                        clientMessage = message[0];
                    }

                    if (item.question_type === SurveyQuestionType.COMMENT_LIST && skip) {
                        clientMessage = t('SKIP');
                    }

                    /* COMMETING LANGUAGE SELECTION FLOW FOR NOW */

                    if (item.question_name === SurveyQuestionType.LANG_SELECTION) {
                        var languageCode = surveylanguages?.find((x) => x.label?.trim() === e[0].label.trim())?.value;
                        if (languageCode) {
                            i18n.changeLanguage(languageCode);
                        }
                    }
                    addUserMessage(clientMessage);
                    handleNewUserMessage(clientMessage, skip, clientMessageList, inputDisabled);
                }
            } catch (ex) {
                console.trace(ex);
            }
        },
        [surveylanguages, inputDisabled, Questionid]
    );
    return (
        <ChatbotContext.Provider
            value={{
                convo,
                setConvo,
                HandleResponse,
                Questionid,
                inputDisabled,
                ChatInputToggle,
                InputDisabledChat,
                InputEnabledChat,
                setQuestionId,
                setSurveyStatus,
                setSurveyLanguages,
                setSessionId,
                statesessionId,
                statesurveyStatus,
                surveylanguages,
                t,
                messageLoader,
                MessageLoaderToggle,
                botReplyLoading,
                setBotReplyLoading,
                documentDownloading,
                setDocumentDownloadLoading,
                addSessionLoading,
                setAddSessionLoading,
                sessionChatHistory,
                setSessionChatHistory,
                actionSelected,
                setActionSelected,
                botControllers,
                setBotControllers,
                intentActionBtnQuery,
                setIntentActionBtnQuery,
                botDetail,
                setBotDetail,
                selectedQuickAction,
                setSelectedQuickAction,
                showQuickActions,
                setShowQuickActions,
                isGeneralQuerySelected,
                setIsGeneralQuerySelected,
                newBotSessionLoading,
                setNewBotSessionLoading,
                sessionMessagesLoading,
                setSessionMessagesLoading,
                expanded, 
                setExpanded
            }}>
            {children}
        </ChatbotContext.Provider>
    );
};

const useChatbotProvider = () => useContext(ChatbotContext);

export default useChatbotProvider;
